
import { Card, CardContent } from "@/components/ui/card";
import { BookOpen, Calendar, GraduationCap, ScrollText } from "lucide-react";

interface CourseStatsProps {
  totalCourses: number;
  liveCourses: number;
  selfPacedCourses: number;
  enrolledCourses: number;
}

export const CourseStats = ({
  totalCourses,
  liveCourses,
  selfPacedCourses,
  enrolledCourses
}: CourseStatsProps) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      <Card className="hover-card bg-gradient-to-br from-white to-accent-subtle/10 border-accent-light/30">
        <CardContent className="p-3 flex items-center gap-3">
          <div className="bg-primary/10 p-2 rounded-full">
            <BookOpen className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-xs font-section text-muted-foreground">Total Courses</p>
            <p className="text-xl font-bold font-heading text-primary">{totalCourses}</p>
          </div>
        </CardContent>
      </Card>
      <Card className="hover-card bg-gradient-to-br from-white to-accent-subtle/10 border-accent-light/30">
        <CardContent className="p-3 flex items-center gap-3">
          <div className="bg-primary/10 p-2 rounded-full">
            <Calendar className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-xs font-section text-muted-foreground">Live Events</p>
            <p className="text-xl font-bold font-heading text-primary">{liveCourses}</p>
          </div>
        </CardContent>
      </Card>
      <Card className="hover-card bg-gradient-to-br from-white to-accent-subtle/10 border-accent-light/30">
        <CardContent className="p-3 flex items-center gap-3">
          <div className="bg-primary/10 p-2 rounded-full">
            <ScrollText className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-xs font-section text-muted-foreground">Self-Paced</p>
            <p className="text-xl font-bold font-heading text-primary">{selfPacedCourses}</p>
          </div>
        </CardContent>
      </Card>
      <Card className="hover-card bg-gradient-to-br from-white to-accent-subtle/10 border-accent-light/30">
        <CardContent className="p-3 flex items-center gap-3">
          <div className="bg-primary/10 p-2 rounded-full">
            <GraduationCap className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-xs font-section text-muted-foreground">Your Courses</p>
            <p className="text-xl font-bold font-heading text-primary">{enrolledCourses}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
